import {container, injectable} from "tsyringe";
import {DynamicLoadHandler} from "./dynamic-load-handler.interface";
import {AbstractLitElement} from "../components/abstract-lit.element";

@injectable()
export class DynamicLoadService {

    public applyForHook(component: AbstractLitElement, key: string, options: Record<string, any>): void {
        const [name, method] = key.split(`:`);
        const handlers = container.resolveAll(name) as DynamicLoadHandler[];
        for (const handler of handlers) {
            // Only methods are hooks; a handler's other members carry the same kind of name.
            const member: unknown = Reflect.get(handler, method);
            if (typeof member === `function`) {
                member.call(handler, component, options);
            }
        }
    }

}